import state from './moduleCrewAccountState.js'
import mutations from './moduleCrewAccountMutations.js'
import actions from './moduleCrewAccountActions.js'
import getters from './moduleCrewAccountGetters.js'

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}
